import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { useAuth } from "@/features/auth/context/AuthContext";
import { useTranslation } from "react-i18next";
import { getAttachmentViewingUrl } from "@/shared/services/uploadService";
import { formatDisplayName } from "@/shared/utils/formatters";

export const TopBar = () => {
  const { userData, logout } = useAuth();
  const { t } = useTranslation();
  const [profilePic, setProfilePic] = useState<string | null>(null);

  // Load profile picture
  useEffect(() => {
    const loadProfilePicture = async () => {
      if (userData?.profilePicId) {
        try {
          const url = await getAttachmentViewingUrl(userData.profilePicId);
          setProfilePic(url);
        } catch (error) {
          console.error("Error loading profile picture:", error);
          setProfilePic(null);
        }
      } else {
        setProfilePic(null);
      }
    };
    loadProfilePicture();
  }, [userData?.profilePicId]);

  return (
    <header className="bg-white border-b border-gray-200 px-3 py-2 md:px-6 md:py-3 flex items-center justify-between">
      <div />

      {/* User area */}
      <div className="flex items-center gap-2 md:gap-3">
        <Link
          to="/settings"
          className="flex items-center gap-2 hover:opacity-75 transition-opacity"
        >
          <span className="text-sm text-gray-600 hidden md:block">
            {formatDisplayName(userData?.lastName, userData?.firstName, userData?.middleName)}
          </span>
          <div className="w-8 h-8 rounded-full border border-gray-200 overflow-hidden bg-gray-100 flex items-center justify-center shrink-0">
            {profilePic ? (
              <img
                src={profilePic}
                alt={formatDisplayName(userData?.lastName, userData?.firstName, userData?.middleName)}
                className="w-full h-full object-cover"
              />
            ) : (
              <svg
                className="w-5 h-5 text-gray-400"
                fill="currentColor"
                viewBox="0 0 20 20"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fillRule="evenodd"
                  d="M10 9a3 3 0 100-6 3 3 0 000 6zm-7 9a7 7 0 1114 0H3z"
                  clipRule="evenodd"
                />
              </svg>
            )}
          </div>
        </Link>
        <button
          onClick={logout}
          className="px-3 py-2 text-sm text-gray-500 hover:text-red-600 active:text-red-700 transition-colors rounded-lg"
        >
          {t("common.logout")}
        </button>
      </div>
    </header>
  );
};
